import * as types from 'modules/tireScan/actionTypes';
import type { ImportSource } from 'modules/tireScan/constants';
import { createReducer, sourceMatcher } from 'utils/ReduxUtils';

const initialState = false;

const loading = (): boolean => true;

const ended = (): boolean => false;

const reducer = (source: ImportSource) =>
  createReducer<boolean>(initialState, {
    [types.FETCH_TIRE_SCAN_REQUEST]: sourceMatcher(source, loading),
    [types.FETCH_TIRE_SCAN_SUCCESS]: sourceMatcher(source, ended),
    [types.FETCH_TIRE_SCAN_FAILURE]: sourceMatcher(source, ended),
  });

export default reducer;
